import EventTopBar from './EventTopBar'

export default EventTopBar
